export var WorkspaceStoragePermission;
(function (WorkspaceStoragePermission) {
    WorkspaceStoragePermission["WORKSPACE_STORAGE_PERMISSION_STORAGE_READ"] = "STORAGE_READ";
    WorkspaceStoragePermission["WORKSPACE_STORAGE_PERMISSION_STORAGE_WRITE"] = "STORAGE_WRITE";
})(WorkspaceStoragePermission || (WorkspaceStoragePermission = {}));
